import React, { useState } from "react";
import { gql, useQuery } from "@apollo/client";
import get from "lodash.get";
import { Flag } from "semantic-ui-react";
import { connectField } from "uniforms";
import { SelectField } from "./SelectField";
import { AccountEntity } from "/imports/api/allAccounts/interfaces/Account";

import Debug from "debug";
const debug = Debug("entities");

const GET_ENTITIES = gql`
  query getAccountEntities($accountId: String!) {
    account: getAccountEntities(accountId: $accountId) {
      id
      entities {
        code
        name
        address
        zipCode
        city
        country
        UID
        registrationNumber
        EORI
        VAT
        email
      }
    }
  }
`;


interface IEntitySelectionField {
  label?: string;
  accountId: string;
  onChange: (entity: AccountEntity) => void;
}

const EntityFields = ({ ...props }: IEntitySelectionField) => {
  const [state, setState] = useState<string>("");

  const { accountId, onChange } = props;
  const { data = {}, loading, error } = useQuery(GET_ENTITIES, {
    variables: { accountId }
  });
  if (error) debug("error", error);
  debug("entities data %o", { data, loading, error });
  const accountEntities: Array<AccountEntity> =
    get(data, "account.entities") || [];

  const entitiesEnabled = accountEntities.length > 0;

  function onSelect(selectedEntityCode: string) {
    setState(selectedEntityCode);
    const entity = accountEntities.find(
      ({ code }) => code === selectedEntityCode
    );

    // eslint-disable-next-line no-unused-expressions
    onChange(entity);
  }

  return (
    <SelectField
      {...props}
      value={state}
      className="entityField"
      label={props.label}
      loading={loading}
      disabled={!entitiesEnabled}
      search
      onChange={onSelect}
      options={accountEntities.map(({ code, name, country }) => ({
        key: code,
        value: code,
        text: code,
        content: (
          <>
            {country && <Flag name={country.toLowerCase()} />}
            {code}
            <span style={{ opacity: 0.5 }}> - {name}</span>
          </>
        )
      }))}
    />
  );
};

// @ts-ignore
export default connectField(EntityFields);
